export default __webpack_public_path__ + "static/drag and drop@3x-54532d09cbf10df7c5507a4ae2534c13.png";